import { typeSafeObjectKeys } from './typeSafeObjectKeys'

export function typeSafeObjectEntries<T extends Object>(
  obj: T
): Array<[keyof T, T[keyof T]]> {
  return typeSafeObjectKeys(obj).map(k => [k, obj[k]])
}
